import { useField as ffUseField, UseFieldConfig } from 'react-final-form';
import { Union } from 'ts-toolbelt';

const useField = <Value, T extends HTMLElement = HTMLElement, InputValue = Value>(
  name: string,
  config?: UseFieldConfig<Union.Nullable<Value>, InputValue>
) => ffUseField<Union.Nullable<Value>, T, InputValue>(name, config);

export default useField;
